export enum GiftCardStatus {
  active = 'ACTIVE',
  deactivated = 'DEACTIVATED',
  blocked = 'BLOCKED',
  pending = 'PENDING'
}

export enum GiftCardError {
  zeroBalance = 'This gift card has zero balance. Please enter another gift card or use a different payment method.',
  deactivated = 'This gift card is no longer active. Please enter an active gift card.',
  blocked = 'This gift card is blocked. Please enter an active gift card.',
  pending = 'This gift card is pending. Please enter an active gift card.',
  invalid = 'Please enter a valid gift card.'
}
